import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Loading, Page, PageBoxContent, PageContainerVCenter, PageHeaderLogo, theme, Typo } from '../../ui';
import { useGetGuestInfoQuery } from '../auth/authApi';
import { useTranslation } from 'react-i18next';
import RegistrationForm from '../../components/RegistrationForm';
import { useGuestRegister } from '../auth/hooks/useAuthActions';
import { useIsLoggedIn, useUser } from '../auth/hooks';

const ResumeRegistration = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { id } = useParams();
  const isLoggedIn = useIsLoggedIn();
  const user = useUser();
  
  const { data: guestInfo, isLoading: guestInfoLoading } = useGetGuestInfoQuery({ id }, { skip: !id });
  const guestRegister = useGuestRegister();

  useEffect(() => {
    if (isLoggedIn) {
      if (user?.email?.toLowerCase() === guestInfo?.email?.toLowerCase())
        navigate('/dashboard')
    }

  }, [isLoggedIn, user?.email, guestInfo, navigate])

  return (
    <Page backgroundColor={theme.colors.PRIMARY} fullheight={true}>
      <PageHeaderLogo />
      <PageContainerVCenter>
        <PageBoxContent>
          {guestInfoLoading ? <Loading /> :
            !guestInfo ?
              <Typo.TextTitle>{t('globals.genericError')}</Typo.TextTitle>
              :
              !isLoggedIn ?
                <RegistrationForm email={guestInfo?.email} handleLogin={() => navigate('/login')} createAccountCall={guestRegister} />
                :
                <div>
                  <Typo.TextTitle>{t('registration.courseAddedToEmail')}: {guestInfo?.email}</Typo.TextTitle>
                  <Typo.Text>{t('registration.wrongAccount')}</Typo.Text>
                </div>
          }
        </PageBoxContent>
      </PageContainerVCenter>
    </Page>

  );
};

export default ResumeRegistration;
